<template>
  <div class="page">
    <navigation
      class="header"
      :theme="{
        background: '#fff',
      }"
    >账号与安全

      <span slot="right" class="modify" @click="$router.push(userInfo.userInfoChangeStatus=== 'NEED_SUBMIT'?'/modify': '/modify/result')" v-if="['NEED_SUBMIT','NEED_REVIEW', 'UPDATING'].includes(userInfo.userInfoChangeStatus) ">修改资料</span>
    </navigation>
    <div class="content">
      <nd-cell
        class="row-item"
        title="手机号"
        :text="userInfo.mobile | mobile"
        :arrow="false"
      />
      <nd-cell
        :class="['row-item']"
        title="注销账号"
        :arrow="true"
        @click="signOut"
      />
      <nd-cell
        :class="['row-item']"
        title="用户协议"
        :arrow="true"
        @click="toProtocol"
        v-if="showTerms==='Y'"
      />
    </div>
    <nd-dialog v-model="unbindPopVisible" @confirm="unBindWechat">
      <div class="unbind-dialog">
        <div class="title">解绑微信</div>
        <div class="description">
          解绑微信账号后将无法继续接受天美贷为您独家准备的活动资讯！
        </div>
      </div>
    </nd-dialog>

    <nd-dialog v-model="showTips" @confirm="copy" :closeBtn="false" confirmText="复制链接">
      <div class="unbind-dialog center">
        <div class="title">提示</div>
        <div class="description">
          复制链接在微信内打开
        </div>
      </div>
    </nd-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import bind from '@/assets/bindWechat.js'
import { copyToClipbord, getKey } from '@/assets/utils'
export default {
  name: 'accountAndSecurity',
  mixins: [bind],
  data () {
    return {
      unbindPopVisible: false,
      userInfo: {},
      isBindWechat: false,
      showTips: false,
      showTerms: 'N'
    }
  },
  computed: {
    ...mapState('user', {
      authStatus: (state) => state.userInfo.authStatus || []
    }),
    realNameAuthed () {
      return this.authStatus.includes('OCR') && !this.authStatus.includes('OCR_EXPIRE')
    },
    showBindWx () {
      const channelNo = getKey('channel') || 'official'
      return channelNo === 'official'
    }
  },
  async mounted () {
    await this.getUserInfo()
    this.termsListUpdate()
  },

  

  methods: {
    ...mapActions('user', ['getUserInfoX', 'agreementUpdateX']),
    ...mapActions('wxBind', ['unbinding']),
    async termsListUpdate () {
      const { success, data } = await this.agreementUpdateX()
      if (success && data) {
        const { show } = data
        this.showTerms = show
      }
    },
    copy () {
      if (!this.isWechat) {
        const userInfo = getKey('userInfo')
        copyToClipbord(`${window.location.origin}/user/wechat/bind?token=${userInfo.token}`)
        this.$message('复制成功')
      }
    },
    async getUserInfo () {
      await this.getUserInfoX({ forceUpdate: true })
      this.userInfo = getKey('userInfo')
      this.isBindWechat = this.userInfo.bindWechat
    },
    bindWechat () {
      if (this.isBindWechat) {
        this.unbindPopVisible = true
      } else if (!this.isWechat) {
        this.showTips = true
      } else {
        this.toBind()
      }
    },
    authOCR () {
      if (this.realNameAuthed) { return }

      // 判断OCR
      if (!this.authStatus.includes('OCR')) {
        return this.$router.push('/authentication/id')
      }

      // 如果OCR过期
      if (this.authStatus.includes('OCR_EXPIRE')) {
        return this.$router.push(
          '/authentication/supplementaryOCR?status=expired'
        )
      }
    },
    async signOut () {
      this.$router.push({
        path: '/mine/signout/risk-notice'
      })
    },
    toProtocol () {
      this.$router.push({
        path: '/mine/protocol'
      })
    },
    async unBindWechat () {
      const { success, data } = await this.unbinding()
      if (success) {
        this.$message(`解绑${data.status ? '成功' : '失败'}`)
      }
      this.getUserInfo()
      this.unbindPopVisible = false
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.page {
  background: #fafafa;
  .modify{
    color: #FF4633;
    font-size: 30px;
    padding: 30px;
    font-weight: normal;
  }
  .content {
    padding-top: 20px;
    .row-item {
      border-bottom: 1px solid #EEE;
      &.gray-text {
        color: #aaa;
      }
    }
  }
  .unbind-dialog {
    padding-top: 10px;
    padding: 0 48px;
    padding-bottom: 80px;
    font-family: PingFangSC-Regular,PingFang SC;
    &.center {text-align: center;}
    .title {
      font-size: 42px;
                height: 72px;
                line-height: 72px;
                font-family: PingFangSC-Semibold,PingFang SC;
                font-weight: 600;
    }
    .description {
      font-size: 30px;
      height: 32px;
      line-height: 1.5em;
      margin-top: 22px;
      font-weight: 400;
    }
  }
}
</style>